// extracted by mini-css-extract-plugin
export var pageSideCopy = "ContentfulBlockSideCopy-module--pageSideCopy--gpa3y";
export var asset = "ContentfulBlockSideCopy-module--asset--EF4yh";
export var largerImage = "ContentfulBlockSideCopy-module--largerImage--7wtBf";
export var content = "ContentfulBlockSideCopy-module--content--+Pepw";
export var even = "ContentfulBlockSideCopy-module--even--+tj3x";
export var largerText = "ContentfulBlockSideCopy-module--largerText--5RFqo";
export var orientationleft = "ContentfulBlockSideCopy-module--orientationleft--c4TEC";
export var orientationright = "ContentfulBlockSideCopy-module--orientationright--8N0r2";